import { usePostHog } from '@posthog/react';
import { env } from '@ui/environment';
import { useCurrentUser } from '@ui/user-context';
import { useEffect } from 'react';
export function PostHogIdentify() {
    const { user, isLoading } = useCurrentUser();
    const posthog = usePostHog();
    useEffect(()=>{
        if (!env.PUBLIC_USE_POSTHOG) {
            return;
        }
        if (isLoading) {
            return;
        }
        if (!user) {
            // Logged out / unauthenticated. Clear identified user and return to anonymous distinct_id.
            posthog.reset();
            return;
        }
        posthog.identify(user.id, {
            email: user.email,
            name: user.name,
            username: user.username,
            role: user.role,
            company: user.company,
            theme: user.theme
        });
    }, [
        isLoading,
        posthog,
        user
    ]);
    return null;
}
